import React, { InputHTMLAttributes } from 'react'

import { mainColors } from '../../styles'
import { Margin } from '../Margin'
import * as S from './SwitchButton.styles'
import { SwitchButtonProps } from './SwitchButton.types'

export const SwitchButton = ({
  checked,
  className,
  defaultChecked,
  disabled,
  id,
  onChange,
  title,
  titleLeft,
  titleMargin = 11,
  labelProps,
  dataCy,
  titleStyle,
  titleColor = mainColors.black,
  ...inputProps
}: SwitchButtonProps & Omit<InputHTMLAttributes<HTMLInputElement>, 'title'>) => {
  return (
    <S.Container className={className}>
      {titleLeft && (
        <Margin right={titleMargin}>
          <S.Title titleColor={titleColor} style={titleStyle} htmlFor={id}>
            {titleLeft}
          </S.Title>
        </Margin>
      )}

      <S.InputContainer disabled={disabled}>
        <S.HiddenInput
          data-cy={dataCy}
          id={id}
          type="checkbox"
          defaultChecked={defaultChecked}
          disabled={disabled}
          onChange={onChange}
          checked={checked}
          {...inputProps}
        />
        <S.SwitchLabel htmlFor={id} disabled={disabled} {...labelProps} />
      </S.InputContainer>

      {title && (
        <Margin left={titleMargin}>
          <S.Title titleColor={titleColor} style={titleStyle} htmlFor={id}>
            {title}
          </S.Title>
        </Margin>
      )}
    </S.Container>
  )
}
